<template>
  <div class="big">
    <div class="right_top">
      <h4 class="right_title">对战宝箱</h4>
      <p class="right_p">对战宝箱奖池库</p>
      <div
        class="right_ul"
        style="width: 100%; display: flex; overflow-y: scroll"
      >
        <div
          class="right_ul_li"
          v-for="itemBox in BoxListdata"
          :key="itemBox.id"
          @click="rightBox(itemBox.id)"
        >
          <div
            class="right_ul_li_box"
            :style="{ backgroundImage: 'url(' + itemBox.back_logo + ')' }"
          >
            <img :src="itemBox.logo" alt="" />
          </div>
          <div class="right_ul_li_data">
            <p>${{ itemBox.coin }}</p>
            <p>{{ itemBox.title }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="big_main">
      <div class="left">
        <div class="left_top">
          <img
            class="left_top_logo"
            src="../assets/img/battleBox/zr.png"
            alt=""
          />
          <div class="left_data">
            <h4>昨日之星</h4>
            <!-- <div class="left_data_u">
                        <img src="https://steamcdn-b.obs.cn-south-1.myhuaweicloud.com/96e2aa4f410349cabe4b6d45b3d62746.jpg" alt="">
                        <div class="left_data_user">
                            <p class="left_data_user_name">马保国之重马保国之重</p>
                            <p>$461.28</p>
                        </div>
                    </div> -->
            <div class="left_data_u" v-if="top10Data.day != null">
              <img :src="top10Data.day.logo" alt="" />
              <div class="left_data_user">
                <p class="left_data_user_name">{{ top10Data.day.username }}</p>
                <p>${{ top10Data.day.coin }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="left_ui">
          <div class="left_li_title"></div>
          <div class="left_ui_">
            <div
              class="left_ui_li"
              v-for="(itemTop, index) in top10Data.data"
              :key="index"
            >
              <div class="left_ui_user_img">
                <img
                  v-if="index <= 2"
                  class="left_ui_user_top"
                  :src="rankingImg[index].url"
                  alt=""
                />
                <img
                  :class="'left_ui_user_img_img' + index"
                  class="left_ui_user_img_img"
                  :src="itemTop.logo"
                  alt=""
                />
              </div>
              <p class="left_ui_li_user-name">{{ itemTop.username }}</p>
              <p class="left_ui_li_user_balance">${{ itemTop.coin }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="main">
        <div class="main_title">
          <div class="main_title_Battle">
            <p
              @click="battleswitch(index)"
              :class="{ isp: index == isp }"
              v-for="(item, index) in arrBattle"
              :key="index"
            >
              {{ item }}
            </p>
          </div>
          <div class="addBattle">
            <p class="addBattle_buttom" @click="addBattle()">
              <i class="iconfont">&#xe614;</i> 创建房间
            </p>
            <p class="addBattle_rule" @click="isrule = true">
              <i class="iconfont addBattle_i">&#xe63a;</i>游戏规则
            </p>
          </div>
          <div class="main_input">
            <p @click="searchRoom"><i class="iconfont">&#xe651;</i>验证游戏</p>
            <input
              type="text"
              v-model="searchRoominput"
              @keyup.enter="searchRoom"
              placeholder="请输入场次编号"
              name=""
              id=""
            />
          </div>
        </div>

        <div class="main_data">
          <div v-if="isp != 0" class="main_data_box">
            <div data-v-66962e63="" class="main_data_title">
              <div class="main_data_casename">箱子信息</div>
              <div class="main_data_user">对战玩家</div>
              <div class="main_data_time">时间/编号</div>
              <div class="main_data_total">总额</div>
            </div>
            <div
              class="main_data_content"
              v-for="(itemnt, indexnt) in Battlerecord"
              :key="indexnt"
            >
              <div class="main_data_casename_img">
                <div
                  class="main_data_casename_backimg"
                  v-for="(itemntid, indexntid) in itemnt.newpond"
                  :key="indexntid"
                  :style="{
                    backgroundImage: 'url(' + itemntid.back_logo + ')',
                  }"
                >
                  <img :src="itemntid.logo" alt="" />
                </div>
              </div>

              <div class="main_data_history_user">
                <div
                  class="avatar-container"
                  v-for="(itemntuser, indexntuser) in itemnt.user"
                  :key="indexntuser"
                >
                  <img :src="itemntuser.logo" alt="" />
                  <img
                    v-if="itemntuser.win == 1"
                    class="_img_victory"
                    src="../assets/img/battleBox/victory.png"
                    alt=""
                  />
                </div>
              </div>

              <div class="main_history_time">
                <p>{{ itemnt.info.create_time }}</p>
                <div @click="copyID(itemnt.info.game_id)" class="main_history_time_copy">
                  <span class="main_history_time_copy_span">复制</span>
                  {{ itemnt.info.game_id }}
                </div>
              </div>

              <div class="main_history_total">
                <img
                  src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAYAAACpSkzOAAAELklEQVRIiY2WXWxUVRDHf2eza9uwLQqS0i8qQltQ0BCMprVo+YqhINRuG6shJBrBiC9gMJKY2FRN9IEENWpiCCYYlCZYiQgk8qWVtZUHq6FIpVUsLAsPTWHbLbR0753x4d62Kbt3YZKTmZNzzvznzMyZM4Y0pF3PGlSfQDSESAWq8xCdhiqIDiDajWoYkc9M+U//ptPl8wQ5v7Yc6ABagblAM1ALPAwsBOqBr4ESYAqAhp8u9tJn0gA9hOgGVHcQuzaMLQuwZBa2TMUWsGQAWy5hyVlTe/aG/loVQPUSoj8jutFUnRryBNILtbmI7EP1JVPy/UX9/akSLHkXW0LYEsASsN1hjfMEtrRgyzsU5oJoM6J+VFeYpeG+JNdpbygH+BGwgD79s2oL0Ak0AAGvm7trDUAnvVdXA0uAfuCEnqgIJgEBXwA2UMNIvAnYCWQkqc0qcEYyZQA7+e9KE7AGSAC7JgHpxbpqYC3QQGJoE7DN0/6C56CwNs0F2caF6CbgeWCdHitfDW6M9GLdH6geYjT+FbZ0YklGUiyyF0PuOgjOc9SNDkJfO3TuTI6bLbewZCFz8tcjutasbF9kNFJfgehJVAsYjX+KLQ1JQc8sgUe+dACGow73Z0MgBw49CSOx24HAkmbm5G9G9CqqS/04b+MI1tAIEErpjOnLHN79AWTkgyh0fezIiUEvF4bovvwKcwuOACEfUAkcBxaQPrsgEZ88v3k53e6Aq/MwMM0PlAJngVmeR2wX4MHXwRqEm1HHbXYsrV1AkVnZvhvY7QfuA/pcwNQU3Qu+IMyscVI7ez5UPQ5XjkJHUzqge/VYuQ/VHJ8LdP5OptH7OYRXQPQA9J92YlNcB6Uv3+lkGXDdZ4r2x0zxtwIM3BEMHNcNdsH5T5x5YGq63TFgBnDdr5H6PYiGScTPeG7PzIcbtwU+kHM3ZkWAxUC3Hyc+q4BvcMpGcuaVvu+k8nDUeT8wUYZif3mBJHCS7C0g7ANagGr8wQxXTqb+kzDigmQVOHygC868B9GjXkAtlBZmAtXAd0Yj9QbRDlQPMhrf61mCxuTZmycebKr1ySVoA6JrzMr2RT5TtF+Bt4E38QcV2O7t8rum7ZQUArzh6p74+LQ3tA/RUkSWMDzYhC3bUlp8T54jxyNeN9pBcV4jqr8g0mOWt70Ak/+jjTiJcIjM7EZgK3Arydbh6ERhnUy3gK3Mzm8EDgB+4NWxxXEg80DLELAcmA6cIivnME4T0oyTQV6UcPcsNOu7PwJmApnAM2Z523jFTWpO9J+aIKq7EF2CaLGZ/4OtbRVT0jUn5M3IQnQLqntMZWtPKmvSdUFFpuxgRM+teQzRRkSOo3rO/V8U0fsRfRTVZYisQvQcqq+ZytbfUunzewGZsoMRV4wBPcCLOHVrrOZcA/4G2oAPgdOmslW99P0PZ9gsvUIyd4IAAAAASUVORK5CYII="
                  alt=""
                />
                {{ itemnt.info.coin }}
              </div>
            </div>

            <div v-if="Battlerecordcount > 0 && isp == 2">
              <el-pagination
                background
                layout="prev, pager, next"
                @current-change="pagedata"
                :total="Battlerecordcount"
                :page-size="limit"
                :current-page.sync="currentPage"
              >
              </el-pagination>
            </div>
          </div>
          <div v-else class="main-rooms">
            <div
              class="main-battle-rooms"
              @click="toBattlerooms(item.info.id)"
              v-for="item in BattlerecordList"
              :key="item.info.id"
            >
              <div class="main-battle-room__info">
                <div class="battle-room-status_finished">
                  <div class="battle-room-status__status">
                    <!-- 结束状态 -->
                    <div class="state_test1" v-if="item.info.state == 1"></div>
                    <!-- 等待 -->
                    <div class="state_test2" v-if="item.info.state == 0"></div>
                    <!-- 进行中 -->
                    <div class="state_test3" v-if="item.info.state == 2">
                      <img
                        class="logo_img"
                        src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAgCAMAAABXc8oyAAAAkFBMVEUAAAD/o03/p1j/oUn/o0z/o03/o0z/o03/o0z/ok7/olH/o03/o03/o03/o03/o03/pE3/o03/o03/pEz/oUv/o03/o0z/o03/o03/o03/pEz/okz/pE3/o07/pVD/o03/o0z/ok3/o03/o0z/pE7/pE3/o03/pE3/o03/o03/o03/o03/okz/pE7/pE7/o00gdWidAAAAL3RSTlMA+wUIOqaRbCAYD/Xiyinr1a+KMiUT7+bbc1JLRTYMzruDfS64oJda6cPBvZ1iX5lAckwAAAEzSURBVDjLjZTpeoIwEAATVG4QkCIKeFV7t/P+b1fy4YG6rcw/YEg2u5tVd4zi2cy11APGdoJBR9v4H61a02PTKJmnlBvskeRZCS1zu8p9P1++TGmJPEHMjfZqnc/kGLV8EsyUg99/9j7NmiP1GGsCZGqI+QH6eYjpFZBe5bmcj0VzAbiXR0fD1JXEVQCLcyIOGNbi+SawOcUR0TG5r3w2/oZCuU33zwnnto8C9M681+w68Q10CIEQoKal297LFjXoWUCibvjhiK6PsQB+7HhSdgxBfWowQM7jlpbi8i2kDVfEhnmviF9QKhnH7leiBpZqCAmUqyHiUqiMTCr1qC9dwdCsebW7t+ddGATxFAj7l6sApPaOQ4yaVe7luq6twQNAporosW/U3zR2ooUhJWLl4tj7BWaVMm13E+ZNAAAAAElFTkSuQmCC"
                        alt=""
                      />
                    </div>
                    <span class="battle-room-status__status__text">{{
                      item.info.state == 0
                        ? "等待中"
                        : item.info.state == 2
                        ? "进行中"
                        : "结束"
                    }}</span>
                  </div>
                  <span class="battle-room-status__rounds"
                    >{{ item.newpond.length }}回合</span
                  >
                </div>

                <div class="main_battle_user">
                  <div
                    class="main_battle_vs"
                    style="
                      background-image: url('data:image/png;base64,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');
                    "
                  ></div>
                  <div
                    :class="'main_battle_user' + indexname"
                    v-for="(itemname, indexname) in userli"
                    :key="indexname"
                    v-if="indexname < item.info.type"
                  >
                    <img
                      class="main_battle_user_wu"
                      v-if="item.user[indexname]"
                      :src="item.user[indexname].logo"
                      alt=""
                    />
                    <img
                      class="main_battle_user_wu"
                      v-else
                      src="../assets/img/battleBox/wu.png"
                      alt=""
                    />
                    <img
                      v-if="
                        item.user[indexname] && item.user[indexname].win == 1
                      "
                      class="main_battle_user_victory1"
                      src="../assets/img/battleBox/victory.png"
                      alt=""
                    />
                  </div>
                  <!-- <div class="main_battle_user2">
                                    <img src="https://akacsgo-b.obs.cn-south-1.myhuaweicloud.com/Uploads/Files/2020/12/22/6374423338454588173635.png" alt="">
                                    <img class="main_battle_user_victory1" src="../assets/img/battleBox/victory.png" alt="">
                                </div>
                                <div class="main_battle_user3">
                                    <img src="https://akacsgo-b.obs.cn-south-1.myhuaweicloud.com/Uploads/Files/2020/12/22/6374423338454588173635.png" alt="">
                                    <img class="main_battle_user_victory1" src="../assets/img/battleBox/victory.png" alt="">
                                </div>
                                <div class="main_battle_user4">
                                    <img src="https://akacsgo-b.obs.cn-south-1.myhuaweicloud.com/Uploads/Files/2020/12/22/6374423338454588173635.png" alt="">
                                    <img class="main_battle_user_victory1" src="../assets/img/battleBox/victory.png" alt="">
                                </div> -->
                </div>

                <div class="area-battle-room__price">
                  <span class="area-battle-room__price__label"
                    >箱子总价格:</span
                  >
                  <span class="area-battle-room__price__value"
                    >${{ item.info.coin }}</span
                  >
                </div>
                <button
                  class="
                    area-battle-room__button area-battle-room__button_status-2
                  "
                >
                  查看
                </button>
              </div>
              <div class="area-battle-room__divider"></div>
              <div class="area-battle-room__awards">
                <div
                  class="area-battle-room__awards_backimg"
                  v-for="(itemp, indexp) in item.newpond"
                  :key="indexp"
                  :style="{ backgroundImage: 'url(' + itemp.back_logo + ')' }"
                >
                  <img
                    :src="itemp.logo"
                    alt=""
                    class="area-battle-room__award"
                  />
                </div>
              </div>
            </div>
          </div>

          <button
            v-if="
              isp < 2 &&
              Math.ceil(BattlerecordListcount / 9) > this.sendpage - 1
            "
            @click="send"
            class="area-battle-rooms__see-more-button"
          >
            加载更多
          </button>
        </div>
      </div>

      <div class="right">
        <h4 class="right_title">对战宝箱</h4>
        <p class="right_p">对战宝箱奖池库</p>
        <div class="right_ul">
          <div
            class="right_ul_li"
            v-for="itemBox in BoxListdata"
            :key="itemBox.id"
            @click="rightBox(itemBox.id)"
          >
            <div
              class="right_ul_li_box"
              :style="{ backgroundImage: 'url(' + itemBox.back_logo + ')' }"
            >
              <img :src="itemBox.logo" alt="" />
            </div>
            <div class="right_ul_li_data">
              <p>${{ itemBox.coin }}</p>
              <p>{{ itemBox.title }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 右侧箱子弹窗 -->
    <div class="backghui" v-if="isboxdetails">
      <div class="boxdetails">
        <div class="boxdetails_title">
          <div
            class="boxdetails_title_data"
            :style="{
              backgroundImage: 'url(' + BoxListdataLi[0].p_back_logo + ')',
            }"
          >
            <img :src="BoxListdataLi[0].logo" alt="" />
          </div>
          <p>{{ BoxListdataLi[0].p_title }}</p>
          <i class="iconfont" @click="isboxdetails = false">&#xe697;</i>
        </div>
        <div class="boxdetails_data">
          <div
            class="boxdetails_data_box"
            v-for="itemBoxli in BoxListdataLi"
            :key="itemBoxli.id"
          >
            <p class="boxdetails_data_box_sum">
              {{ itemBoxli.odds | numFilter }}%
            </p>
            <img :src="itemBoxli.logo" alt="" />
            <p class="boxdetails_data_box_name">{{ itemBoxli.title }}</p>
            <span>${{ itemBoxli.money }}</span>
          </div>
        </div>
      </div>
    </div>
    <!-- 规则弹窗 -->
    <div class="backghui" v-if="isrule">
      <div class="rule">
        <div class="rule_title">
          <p>游戏规则</p>
          <i class="iconfont" @click="isrule = false">&#xe697;</i>
        </div>
        <div class="rule_data">
          <p>
            1，创建房间时可以选择对战人数（1V1，3人对战和4人对战），一场对战最多可以选择5个宝箱。房间一但创建，不可取消。
          </p>
          <p>
            2，对战入场费用即本场对战开启的宝箱价值总和，支付费用后，即视为加入房间，中途退出房间并不会退还宝箱或入场费。
          </p>
          <p>
            3，当一场对战有多名赢家均分奖励时，本局所有玩家所得饰品将发放至本局赢家的个人背包中。
          </p>
          <p>
            4，每场游戏的结果受到创建时间，玩家ID，玩家位置和开始时间等多方面因素影响，为完全随机产生的结果
          </p>
        </div>
      </div>
    </div>
    <!-- 创建房间弹窗 -->
    <div class="backghui" v-if="isaddhouse">
      <div class="addhouse">
        <div class="addhouse_title">
          <p class="_title_round">
            <span>{{ addBoxRound }}</span
            >回合
          </p>
          <div class="_title_model">
            <p
              :class="{ isaddhouse: index == addhouseindex }"
              @click="handleaddhouse(index)"
              v-for="(item, index) in addhouse"
              :key="index"
            >
              {{ item }}
            </p>
          </div>
          <p class="addhouse_sum">
            箱子总额<span>${{ addBoxtotal | numFilter }}</span>
          </p>
          <i class="iconfont" @click="isaddhouse = false">&#xe697;</i>
        </div>
        <div class="addhouse_main">
          <p class="addhouse_main_p">添加箱子</p>
          <div class="addhouse_main_ul">
            <div
              class="addhouse_main_li"
              v-for="(itemAdd, index) in addBoxDdata"
              :key="index"
            >
              <div class="addhouse_main_li_sum">
                <div>
                  <i
                    v-show="itemAdd.sun_d != 0"
                    class="iconfont"
                    @click="addhouseSumjian(index)"
                    >&#xeaf5;</i
                  >
                </div>
                <p>x {{ itemAdd.sun_d }}</p>
              </div>
              <div
                class="addhouse_main_box"
                :style="{ backgroundImage: 'url(' + itemAdd.back_logo + ')' }"
              >
                <img :src="itemAdd.logo" alt="" />
              </div>
              <p class="addhouse_main_li_name">{{ itemAdd.title }}</p>
              <span>${{ itemAdd.coin }}</span>
              <div class="addiconfont" @click="addhouseSum(index)">
                <i class="iconfont">&#xeaf3;</i>
              </div>
            </div>
          </div>
          <p class="addhouse_main_buttom" @click="addBattleajax()">创建房间</p>
        </div>
      </div>
    </div>
    <!-- 验证游戏弹窗 -->
    <div class="backghui" v-if="isVerificationgame">
      <div class="Verificationgame">
        <div class="Verificationgame_title">
          <p>公平性说明</p>
          <i class="iconfont" @click="isVerificationgame = false">&#xe697;</i>
        </div>
        <div class="Verificationgame_main">
          <div class="Verificationgame_main_tit">
            <div class="Verificationgame_main_tit_">
              <div>
                <div class="Verificationgame_youxi">
                  <img
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAcCAYAAABlL09dAAACC0lEQVRIS7WWTWsTURSGnzeYWOqmflQUQeJGEHEh2cy4EFFQUQR3KkgFMaTiSv0XLtxmpqUVXAiCCMWPjVSXaRFxIYgLQReCrixF60fSzJGbMUXsTJJJ0wuzmXvPM++997znjGz64CiNoSngJJCn99Ekx2WVa3eTQmSh/xg4DXwDW+qBuwVUAJqttSlwWeA3EAtQL6ry6kc3sE34LzCOYHYT6dbf9WOq1O79G+sUG/BOldq+blA3vwJeXt5JYcNxIqbda8wuanzufpuxJrCuvfxik/5YEnzN4NYuql6ZHAEowqILGp9/kB0c+LOIo0S2R1fnPra3bhNeGWvBm0Scyw4O/dvAdaAGzMdgM9Bv4AywH/jeB7i0DQrPgQMdLvtXZnBLX1jKY4XD5KLRVXDLVYGhvsCd0tJC7zNoZB3A/idg6yqwmW0GKsDGFGXOUI8kvU6at9D/ALY7CXwFmOziwhlJZ9PBFJPAw8B5wBWaxFhgVtL7TOBe6kXny3NHkaB43cBmVgJc4U+7vP+//RO4JOlNnOMpis3M2XIGUI/qI9d9JD3rCI6db5sytKmGpJXOY6H3FrR38AYJ/GPO6gMH991Bejx3Bq7YAu8OsGvw4DjddrTb/1eWKOpGzeVk38PC0jAUXHXLywLvCdIpcP8WLPZNjQNH4sceyqqHtiObQpzIkLtp9akOegr18h9N7TtDYIKT9AAAAABJRU5ErkJggg=="
                    alt=""
                  />
                  <div class="Verificationgame_youxi_data">
                    <h4>游戏编号</h4>
                    <p>{{ Verificationgame.info.game_id }}</p>
                  </div>
                </div>
                <div class="Verificationgame_youxi">
                  <img
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAEK0lEQVRIS7WWXYhUZRjHf/8z62c3mlEtFCmY9EGrFc7MkT7EXRLKSKishY0wdGZ2C/OiLLtaIlrtQi3RnZGskASpMBAVor3Yi5ozuxrrR0GFmVEhVoY3tZvtnCfec2ZtP2Y/tO25PO/zPP/zf9//8yHGMWvF47rkUhLeQ5h8zBYgzYrCzC4gfYssQN4hfi52qpVwrJQa7dBal9Zwfd8axAbQvPF+rHJ+GniD2cHbWkW5WkxVQCv4dwB7gEVxkBlGEdGBeV8S9p8jIcN0LdLtQD3YvSCvAnIM9Tcpc+Sr4aAjAK2QXAneXtBMoIzZe8hrU7b43UCwmU2VdHFwMmtPzyXBi5gyQA3Yn4hGZUoHBvsNAbT8kkeQfRQHcAYvbNTartKQxGYbgdeAJyV9OJyBFdJ3YexDuhmjH88eHQx6CTC+RitFzMyOY94Dai7+MiKh2cfASmCTJAc+wmyLfzVX2WFQCuwPVE4NXG8EWBHIUaSFwA/0himt7zpXNdkEAKOcMWgAWgD0MDtY7IQUAxbSzaCdYCEh96m59Pmo6p0gYJS33b8T0Y3cEymrbHGX7HESNPingLkYe5QLnh6rBOwyAGMy/nbgOeA0mWC+bFe6AdOn7gy4Tdng60kF3LH4RmpqvgcSEC6T5f1tiOeBI8oGyfEK/HIZVlh2RLUq2yIrpJ0yU5HqskFV1Q0ri3FVOkLZeX8j4nUgkBX834A5yJqUKe39Xxjm0w8jHcDsvGMYguJ6NHrxWKVMcHACKu0EPhnm9zuwW1LUR63dX4H4ADGj4ld2DPvjB62Y9KwyxZ1jALru8tgYN7FC0qEIcNeSFsx2DPKNAOMrNV6F8n5y3ScUK7aqmVk98BIwpYqDy5WTdD6+MEQ+WYd5y/G0GdyV5tMBUhqjTbnglfHe8ErOreC/DLQNiGYrsN51BGUCp9ZJNyv4rs4bgG1DC7/8961qOfrNZCLaW6kbmOadiXRiNChaIWp9N6lvcrNPudLqSQUspN8ErQM7Q0dpfty886kW5O2Imrd59yhXDCYD1Ham6kh4R2OBWYuypfZ/x1Nt3xegumjwTulL6pmeX/8LqG1dNIuZM9yP3wJ2grPT71ZrZ//QAWx0VYq0h7/6lmvdlYFWwFwtLomaiUgpG5x0BIauGNE+k3CF7VaM04Q0qjnoHs7UtifnMSOR0JrAjbUhZvnkQpTYFzOjH7MnlCvtv9RXRgTEoK6nxksU7MYrb9LabjdisHfnTudirVs9pjC1t1arj12IvkdjKPECqDk6c8ywpsFgIxgOgFf2m/crb+rSuX77Gbg1MfwJee/EvmEWdA2mesT9g1rkSaz8lHLdx4cTGmcR7s0gb0NUMhMxsx+RNnN2WsEJpFrIqICX2LoVpD61DHkPgvng1j+bFb++LmB2ClEiDA8zp7tjtI17IN8/8yzMoodHG8MAAAAASUVORK5CYII="
                    alt=""
                  />
                  <div class="Verificationgame_youxi_data">
                    <h4>开始时间</h4>
                    <p>{{ Verificationgame.info.create_time }}</p>
                  </div>
                </div>
              </div>
              <div class="win_user">
                <div class="win_user_data">
                  <img
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAADBklEQVRIS8WWTYiVVRjHf/87ttEWjQVRLsrUgtJpIdg7GSJhBAlulECKPojmNhOCluBGcUQ3gh9BOHPnBmqhCKIbQSGCgqjmjXBhky4mP3IhoejoQluU9/7lfe+Z631n7tx7Z8jxLM95nvM7z3OeL9FkuZccT0evY63EjkALEI+lauYW+E+kmJJPci3+Xr2UG12piQ59lDZuRl2gTcAzzR4Wzi+Dd9IeF/U2pXo6dYHuf3UhufIh0MtZJQ8DQ5ir6b54ElgEen6M3BnKuXfV/csfY6HjgC5GqzBHQDOD8Aj4S8ocVHf8V71Xuz96lhwfgNYBsysy/gexVl3xiVqdDLAC03FgRhDaT+n2RvUM3WzFpe5b1E5u1m6kD4P8XeTVtdAqMLjx12BZCblbXfFXrYDGyrgYfYzVD7SllpZzr4y6NwWGADld/TO5a6qwUXiAFoN7z9AeL04CqQIciLpBfaNuVH7wo6lYNs7SQrT/vnvdo3zcrzTPnuq8GEJ/hNLt+a3+WbNHpX/a9uj5EEiX+XvwObkYrcD6Lpi+Tfm4t9lFkzn3QNQL2prqlPyGPNC5F1ifbpQ9d6LQnwykVraSMroU9r6QC9EgUgQeVj5+YaoXN9JzIRpGWoAdy4XO64jHwceVj9c8EOBAdAy0GnMjcendNF/sPn0Sf/pAgIVoH1JP8osPATjtLm0QNLZfAt4BFkt6s2Fg2N8Cp4HDks5mIjUTNA3SwvZ2YHNQfk3Sz/WgtpcCP4WzHZK2VEvcuLRokPi2XwSSnpaUwCFguaSRzOvtpB39AHSkMwAslHSuCqxNfCWJ36S02f4aeC9ccAVICsWopYllG4A54fwbSe9XYfVKW7PibXsWcApY1iRlfgTeknSnCqxXvFNgZX6ZsD3ZfgTYCHwGPDEGfB3YA+yS9F8VVumJ9dtTCq3MMQ0bcAAvAeaFiy8Av0n6N/OvzRpwzauyI4Z9gPKdz1ttV5MaMbLQaRqi7ufOBGOik6GX3zNjoulIO0FmufUxsQqdzkE4EwD/86h/D9sJsFKtRX1rAAAAAElFTkSuQmCC"
                    alt=""
                  />
                  <h4>获胜玩家</h4>
                </div>
                <div class="win_user_data_vit" v-if="Verificationgame.user.length == Verificationgamevt">
                  <p style="font-size: 18px;">平 局</p>
                </div>
                <div class="win_user_data_vit" v-else>
                  <div v-for="(itemVer,indexVer) in Verificationgame.user" :key="indexVer">
                    <div v-if="itemVer.win == 1">
                      <span>{{ itemVer.username }}</span>
                      <p>( 桌：{{ indexVer + 1 }} )</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="verification_model__content__top__main">
              <img
                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAEbklEQVRIS62Wf2jUdRjHX++726abZgqGQpiEFaVpNW33nWjBgsK0QkgoyDLmbpmprPIPI5xR/mEmKaa7OTIMjIrAUiQyyRJ3Z7pISyEUMi38kbgU3dzc7YnP9256d7u7bdHzz/34PO/n/TzP5/k8zyP+g1jU2+dgisSmDhSugQKs/uEQozou+7gzJUNUv6drIDb6JLRoeSkUP4UxE1kYNAYIpkgSYCcxxRE7oHObIi1thRzIS2hbJpbRXvoapsWI4WlGLoOVJX/rCjDk+pnRimwtg9tWa+5hd9ZLchLahgenEQxuAcYCBuymm09IaLcWNv9hUa89dYeDbX3lbQStigDPAFXOC+AEicRcLfhxbzZjL0Jr9F7EaACKMPYiW6JI/Kd0YDph5v/hBzC9j5gGXEPUqib2YbpOBqE1VMxDavIVLLCcM80rVU93tpf5CH1YPQFGVS5D3SuSdqxatfs399i4TmgNlR6y78FCSNXZnvUnwgwdP1PWBOrC9JBqm2P+NfhOrBtXQsnIX4FxYCsUidcXqrRCEWaluB60HDhOx98TtOh4R5Iw6r0OrALbz7fxqfqcxP9C+DRBHgnvA1UASxWJvSuLlhdhRSeRRiGmqibWXJDMLMQXz/+OAsbszbdLKvjwrdGrxNiH2Rl0bYys0ZuJsR2IKRKrzEdmZiXAm8DLwM0pvX+AjcBbkq7mxUY9F4SHmCWLhjeAXgJbrEh8XS6QmRUDu4Dp4Fft4dTnfUAA2AM8KqkzJz4aXgRaC7ZRFvUOAJNJdE/Sgv3OUC8xszeAt/3LhyclHU1WvN0NfAnc4aKX5HR64zdUTCQYOAQcdIStmN1E5/lSV0V5CE8BtzrHJLVkVKLZ/YBz+htJM3LiPxtfzIWh7UiXXEoToDa6upyXN6QjdFF1sXYzc330AnBK8ht3rgy41P4p6bwf+RpvMCVdwzIUQ6FjYKUuwrPALTmsPKHa+HYzGwpcAs7KVXI/xBrCs5C+yqF6zkX4DmhZxqHxF+q8s2fUmNkR4B7gcUk7s1I6EkhIclnwJTnSin4DuWtIE1vZ8w5dw60GFYO1EOx6QdUHXedJGjCbB7gm3ArUANtSR7OBKHBO0l0ZppsmTyAR+ghUDtaJ0YSuLbnRSzePHUTr6FLVxa57mhVJIzA/9V9Pcbm36WS9pFdyZdvWeCMYfrpN807477TPiZ9FOgdYhHW7ygQFfgbWSfq0H1ebhPRXMYM4bQAPFJ974kfLhynScjGfsf5MC8tjI8fED8/H1IjxASMu1WnOkV7tquAAdo+8deh7oIXIalQT35TueG/ChinTUXAnqAyzo5B4VbUHvu5PSq1hymMotBoYD3YFC8xQbfMPBQn9ZxD17gX7GDQp9TAOY2yF7t20BY9Q5nceuMIIShPjIVCFeBY0MaV/CPScIrFfsq8l/5roFt7RV+eDlqa2tx6s2+J6cOnf3fkJsFWcHrQp34LcZ5Uml6KKKqSZgJvc4zCGIzmyi2DH/EU4YDvYFf+ur23hX6q63YgPTZDCAAAAAElFTkSuQmCC"
                alt=""
              />
              <div>
                <div
                  class="verification_model__content__top__header__left__noGame"
                >
                  本场随机性
                </div>
                <div
                  class="verification_model__content__top__header__left__num"
                >
                  {{ Verificationgame.info.game_random }}
                </div>
              </div>
            </div>
            <div class="verification_model__content__title">参与玩家</div>

            <div
              style="padding: 20px; display: flex; justify-content: center"
              class="participateUser"
            >
              <div
                class="verification_model__tail__item"
                v-for="(itemve, indexve) in Verificationgame.user"
                :key="indexve"
              >
                <div class="verification_model__tail__item_user">
                  <img :src="itemve.logo" />
                  <img
                    v-if="itemve.win == 1"
                    class="verification_model__tail__item_user_victory"
                    src="../assets/img/battleBox/victory.png"
                    alt=""
                  />
                </div>
                <p class="verification_model__tail__item_p">
                  {{ itemve.username }}
                </p>
                <span class="verification_model__tail__item_p_span"
                  >桌{{ indexve + 1 }}</span
                >
                <div class="verification_model__tail_big">
                  <div
                    class="verification_model__tail"
                    v-for="(itemsu, indexsu) in itemve.su.data"
                    :key="indexsu"
                  >
                    <p>{{ itemsu.title }}</p>
                    <div class="verification_model__span">
                      <span class="verification_model__span1">奖励</span>
                      <span class="verification_model__span2"
                        >$ {{ itemsu.coin }}</span
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 手机端浏览器 -->
    <div class="TopApp" @click="drawer = !drawer">
      <p>对战排行榜</p>
    </div>
    <el-drawer
      title="我是标题"
      :visible.sync="drawer"
      direction="ltr"
      size="50%"
      :with-header="false"
    >
      <div style="display: flex; height: 100%">
        <div class="left_ui_" style="background: #24242b; width: 100%">
          <div
            class="left_ui_li"
            v-for="(itemTop, index) in top10Data.data"
            :key="index"
          >
            <div class="left_ui_user_img">
              <img
                v-if="index <= 2"
                class="left_ui_user_top"
                :src="rankingImg[index].url"
                alt=""
              />
              <img
                :class="'left_ui_user_img_img' + index"
                class="left_ui_user_img_img"
                :src="itemTop.logo"
                alt=""
              />
            </div>
            <p class="left_ui_li_user-name">{{ itemTop.username }}</p>
            <p class="left_ui_li_user_balance">${{ itemTop.coin }}</p>
          </div>
        </div>
      </div>
    </el-drawer>
    <!-- 复制 -->
    <input
      style="position: absolute; top: 0; left: 0; opacity: 0; z-index: -10"
      type="text"
      name=""
      id="inputcopy"
    />
  </div>
</template>

<script>
export default {
  data() {
    return {
      userli: "11111",
      rankingImg: [
        {
          url: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAATCAYAAAB7u5a2AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAbNJREFUeNpi/P9Zj4FI4ADEMUD8Aohr4KI8F3FqYPn/lyiDTYB4PxLfDogdgfgvIx5NLP/+EGV4NRrfFmrBfmb8hv8nxvB7WMTegAhmKri8Doi1gdgdiN8DcS0QXyakienfLwYGIOaC0rjwVyAOhbIfAvFUmBw28P2+HifY8L+//88D4idAXADEDHjwcihtAMSOMHF08OWWbgxQ/CmQXsfy9xdDBFAMZJMyHh86AbE3En8REMtiUwg0TxpICQJxIChYdID4FhCz4AgSkJoNaGIyQJyLLViAYl+A+A0QGwNd/v8eNFOsAmIDIG4C4u1I6ruAmBeLI1uBeCkQvwMnnRM6KtCIjwXiuSIWV84xAb0B8soJKG0BxNuAeBGULwrExVA2OuYF4gaQwS8P6YDU3ATiWKjcSZA449PdWjCX3EELdxD/HxCr4YmLL0B8FYjN0cS1pVyuXmNBCrcjaIarEJH+ebAY/FLG6+o1cCb6izD8EBDHM1AODsFzKFJaPc9AHYAwHClYbgMxiMdGoeFnsJUtX6CuN6fQ8Fu4SsXjFBp+TyP5+jtcpeImaMlHLliCzAEIMADKqBBGdVjFDAAAAABJRU5ErkJggg==",
        },
        {
          url: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAATCAYAAAB7u5a2AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAbtJREFUeNpifPH8LgORwAGIY4D4BRDXwATFJZRwamD59/8/MQabAPF+JL4dEDsC8V98mlj+/f1HjOHVaHxbqAX78Rr+999fYgy/h0XsDSFNLH+Jc3kdEGsDsTsQvwfiWiC+TEgT098/fxmAmAtK48JfgTgUyn4IxFNhctjAnduXOcGG//n7dx4QPwHiAiBmwIOXQ2kDIHaEiaODGzcuxADFnwLpdSx//vyNAIqBbFLG40MnIPZG4i8CYllsCoHmSQMpQSAOBBmuA2RsB4U/rqAD4g1oYjJAnAvEk7EY/gUa2e4swHC7B80Uq4DYAIiboJbBQBcQ82KxtBWIlwLxOxDn7JnjKtCIjwXiucYmludYfv/5A5I7AdVgAcTbgHgxEMcBsSgQF+PwEcjCBiDOO3HicDHUEUxQuZOQpAiJ8cdAfBcp3EG2WwIxoXSaePTIATMgbY4mfhRs+B9EcjqCFqkqRKR/HiwGv7R3cL4GMRyRnA4BcTwD5eAQPIciufw8A3XAIaTsDzf8NhD/AmI2Cg0/g61s+QJ1vTmFht/C5nIQOE6h4fcCAgLfIcrzfyiVxSZoyUcuWILMAQgwAESt6TJ85BmVAAAAAElFTkSuQmCC",
        },
        {
          url: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAATCAYAAAB7u5a2AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAbFJREFUeNpiPNVlx0AkcADiGCB+AcQ1MEHT0oM4NbD8//ePGINNgHg/Eh/kIkcg/otPE8u//0QZXo3Gt4VasB+/4cS5/B4WsTeENLH8+0uU4XVArA3E7kD8HohrgfgyIU1M//79ZQBiLiiNC38F4lAo+yEQT4XJYQOHGk04IYb//TsPiJ8AcQEQM+DBy6G0ARA7wsTRwYE6wxig+FMgvY7l79+/EUAxkE3KeHzoBMTeSPxFQCyLTSHQPGkgJQjEgSCX6wDxLSBmweFikJoNaGIyQJyLzeVAsS9A/AaIjYEu/3MPmilWAbEBEDcB8XYk9V1AzIvFka1AvBSI34E4O0rVVaARHwvEcz26b55j+guMFCA+AaUtgHgbEC+C8kWBuBjKRse8QNwAMnhrsQpIzU0gjoXKnQQnxb8Qrz0G4rtI4Q6y3RLkSwKpLXFTgaIZkDZHEz8KTed/YAJH0CJVhYj0z4PF4JcBkx9fQ3Y5OHkCcTwD5eAQUg6FG36egTrgELay5TYQ/wJiNgoNP4PN5V+grjen0PBbuErF4xQafi96wYd3uMrzTdCSj1ywBJkDEGAAaf1QpObl7bYAAAAASUVORK5CYII=",
        },
      ], //排名头冠
      isboxdetails: false, //右侧箱子详情页弹出
      arrBattle: ["对战桌面", "对战历史", "我的对战"], //
      addhouse: ["双人模式", "三人模式", "四人模式"], //
      input: "",
      isp: 0, //对战index
      Battlerecord: [], //对战记录  全部和我的都在这里 因为页面一样
      limit: 9, //一页多少条
      Battlerecordcount: 0, //总共多少条
      BattlerecordBox: [], //对战记录箱子
      BattlerecordList: [], //房间列表
      BattlerecordListcount: 0, //总共多少条
      isrule: false, //规则
      addhouseindex: 0, //模式
      isaddhouse: false, //创建房间
      client_id: "", //websocket初始化id

      websock: null, //建立的连接
      lockReconnect: false, //是否真正建立连接
      timeout: 8 * 1000, // 5+1~2秒一次心跳
      timeoutObj: null, //心跳心跳倒计时
      serverTimeoutObj: null, //心跳倒计时
      timeoutnum: null, //断开 重连倒计时
      testsocket: true, //离开断开

      against_suclos_i: "", //长连接找到房间的id
      top10Data: "", //排满前10
      oneDataday: "", //昨日之星
      BoxListdata: "", //全部对战箱子
      BoxListdataLi: "", //单个对战箱子数据
      addBoxDdata: [], //创建房间箱子数组
      addBoxDdataList: [], //创建房间箱子数组发送的箱子id
      addBoxRound: 0, //创建房间箱子回合
      addBoxtotal: 0, //创建房间箱子价格总数
      searchRoominput: "", //搜索输入内容
      sendpage: 2, //查看更多页数
      currentPage: 1, //分页默认为第一页 点击后恢复第一页
      Verificationgame: [], //验证游戏
      Verificationgamevt: 0, //几位胜利者
      isVerificationgame: false,
      drawer: false, //手机端浏览器
    };
  },
  

  mounted() {
    this.client_id = this.$store.state.client_id;
    this.getTop10();
    this.getBoxList();
    this.getroomList();
  },
  filters: {
    numFilter(value) {
      // 截取当前数据到小数点后两位
      let realVal = parseFloat(value).toFixed(2);
      return realVal;
    },
  },
  created() {
    //页面刚进入时开启长连接
    
  },
  destroyed() {
    this.testsocket = false;
    //页面销毁时关闭长连接
    
  },
  computed: {
    socketData() {
      return this.$store.state.socketData; //需要监听的数据
    },
    clientId() {
      return this.$store.state.client_id;
    },
  },
  watch: {
    //监听是否手机端浏览器  触发element组件
    drawer() {
      if (this.drawer) {
        document.getElementsByClassName("TopApp")[0].style.left = "50%";
      } else {
        document.getElementsByClassName("TopApp")[0].style.left = "0%";
      }
    },
    
    clientId(data, old) {
      console.log("绑定");
      this.client_id = data;
      this.bind();
    },
    socketData(data, old) {
      if (data.code == 0 && data.msg == "成功") {
        this.BattlerecordList = [];
        data.data.room.map((item) => {
          // 把箱子id取出来转换为数组  然后数组去遍历出所有id对应的箱子 拿到数组  放会每个item里面
          let arr = [];
          let lengt = item.info.pond_id.split(",");
          for (let i = 0; i < lengt.length; i++) {
            for (let j = 0; j < item.pond.length; j++) {
              if (lengt[i] == item.pond[j].id) {
                arr.push(item.pond[j]);
              }
            }
          }
          item.newpond = arr;
          this.BattlerecordList.push(item);
        });
      } else if (data.type == "against_create") {
        var searchList = [];
        searchList.push(data.data);
        searchList.map((item) => {
          // 把箱子id取出来转换为数组  然后数组去遍历出所有id对应的箱子 拿到数组  放会每个item里面
          let arr = [];
          let lengt = item.info.pond_id.split(",");
          for (let i = 0; i < lengt.length; i++) {
            for (let j = 0; j < item.pond.length; j++) {
              if (lengt[i] == item.pond[j].id) {
                arr.push(item.pond[j]);
              }
            }
          }
          item.newpond = arr;
          this.BattlerecordList.unshift(item);
          if (this.sendpage == 2 && this.BattlerecordList.length == 10) {
            this.BattlerecordList.pop();
          }
        });
      } else if (data.type == "against_rank") {
        this.top10Data = data.data;
      } else if (data.type == "against_add") {
        for (let i = 0; i < this.BattlerecordList.length; i++) {
          if (this.BattlerecordList[i].info.id == data.data.info.id) {
            this.BattlerecordList[i].user = data.data.user;
          }
        }
      } else if (data.type == "against_suclos") {
        for (let i = 0; i < this.BattlerecordList.length; i++) {
          //循环拿到第几个房间
          if (this.BattlerecordList[i].info.id == data.id) {
            this.BattlerecordList[i].info.state = 2;
            setTimeout(() => {
              this.BattlerecordList[i].info.state = 1;

              //循环拿到获胜者
              for (let o = 0; o < this.BattlerecordList[i].user.length; o++) {
                for (let p = 0; p < data.data.length; p++) {
                  if (
                    this.BattlerecordList[i].user[o].uid == data.data[p].uid
                  ) {
                    this.BattlerecordList[i].user[o].win = 1;
                  }
                }
              }
            }, (Math.floor(Math.random() * (7 - 3 + 1)) + 3) * 1000);
          }
        }
      }
    },
  },
  methods: {
    //复制游戏ID
    copyID(event) {
      console.log(event);
      var input = document.getElementById("inputcopy");
      // input.value = this.redData[0].share + '?code=' + this.$store.state.userdata.code; // 修改文本框的内容
      input.value = event; // 修改文本框的内容
      input.select(); // 选中文本
      document.execCommand("copy"); // 执行浏览器复制命令
      this.$message({
        message: "复制成功",
        type: "success",
        showClose: true,
      });
    },
    //查看更多
    send() {
      // let data = JSON.stringify({ "type":"against_list","page":1 })
      // this.websock.send(data);
      let is = this.BattlerecordListcount / 9;
      if (Math.ceil(is) < this.sendpage) {
        return;
      }
      this.$axios({
        url: "worker/against/room/list",
        method: "post",
        data: {
          page: this.sendpage,
        },
      }).then((res) => {
        if (res.status === 200) {
          this.BattlerecordListcount = res.data.data.count;
          res.data.data.room.map((item) => {
            // 把箱子id取出来转换为数组  然后数组去遍历出所有id对应的箱子 拿到数组  放会每个item里面
            let arr = [];
            let lengt = item.info.pond_id.split(",");
            for (let i = 0; i < lengt.length; i++) {
              for (let j = 0; j < item.pond.length; j++) {
                if (lengt[i] == item.pond[j].id) {
                  arr.push(item.pond[j]);
                }
              }
            }
            item.newpond = arr;
            this.BattlerecordList.push(item);
          });
          this.sendpage++;
        }
      });
    },
    //连接绑定
    bind() {
      if (!localStorage.getItem("token")) {
        return;
      }
      this.$axios({
        url: "/worker/user/bind",
        method: "post",
        data: {
          client_id: this.client_id,
        },
      }).then((res) => {
        if (res.status != 200) {
          this.$message({
            showClose: true,
            message: res.data.msg + "请刷新页面~~",
            type: "success",
          });
        }
      });
    },

    //获取对战箱子详情
    rightBox(id) {
      this.$axios({
        url: "/pond/Against/shop/List?p_id=" + id,
        method: "get",
      }).then((res) => {
        if (res.status === 200) {
          this.BoxListdataLi = res.data;
          this.isboxdetails = true;
        }
      });
    },
    //对战
    battleswitch(index) {
      this.isp = index;
      if (index == 2) {
        this.currentPage = 1;
        if (!localStorage.getItem("token")) {
          this.isp = 0;
          this.$message({
            showClose: true,
            message: "请先登录",
          });
          //提示登录框
          setTimeout(() => {
            this.handleZhu();
          }, 300);
          return;
        }
        this.getuserroom();
      } else if (index == 1) {
        this.currentPage = 1;
        this.Battlerecord = this.BattlerecordList;
        this.Battlerecordcount = this.BattlerecordListcount;
      }
    },
    //模式切换
    handleaddhouse(index) {
      this.addhouseindex = index;
    },
    //获取排名前10  未完成
    getTop10() {
      this.$axios({
        url: "/worker/against/rank/getTop10",
        method: "post",
      }).then((res) => {
        if (res.status === 200) {
          this.top10Data = res.data.data;
        }
      });
    },
    //获取对战房箱子
    getBoxList() {
      this.$axios({
        url: "/pond/Against/List",
        method: "get",
      }).then((res) => {
        if (res.status === 200) {
          this.BoxListdata = res.data[0].list;
        }
      });
    },
    //创建房间
    addBattle() {
      this.addBoxDdata = [];
      this.addBoxRound = 0;
      this.addBoxtotal = 0;
      this.isaddhouse = true;
      this.BoxListdata.map((item) => {
        // this.addBoxDdata.push(Object.assign(item,{sun_d:0}))
        let i = item;
        this.$set(i, "sun_d", "0");
        this.addBoxDdata.push(item);
      });
    },
    //添加箱子
    addhouseSum(index) {
      // let i = parseInt(this.addBoxDdata[index].sun_d) + 1
      // this.$set(this.addBoxDdata[index],'sun_d',i)
      if (this.addBoxRound >= 5) {
        this.$message({
          showClose: true,
          message: "最多只能 5 回合~~",
          // type: "success",
        });
        return;
      }
      this.addBoxDdata[index].sun_d++;
      this.addBoxRound++;
      this.addBoxtotal += parseFloat(this.addBoxDdata[index].coin);
    },
    //减少箱子
    addhouseSumjian(index) {
      // let i = parseInt(this.addBoxDdata[index].sun_d) -1
      // this.$set(this.addBoxDdata[index],'sun_d',i)
      this.addBoxDdata[index].sun_d--;
      this.addBoxRound--;
      this.addBoxtotal -= parseFloat(this.addBoxDdata[index].coin);
    },
    //登录
    handleZhu() {
      document.getElementsByClassName("form-wnd")[0].classList.add("active");
      document.getElementsByClassName("popup-bg")[0].classList.add("active");
      document
        .getElementsByClassName("switch-block")[0]
        .classList.add("active");
      document
        .getElementsByClassName("switch-block")[1]
        .classList.remove("active");
      document.getElementsByClassName("button")[0].classList.add("active");
      document.getElementsByClassName("button")[1].classList.remove("active");
      this.isBar = false;
      this.password = "";
    },
    //发送请求创建房间
    addBattleajax() {
      if (!localStorage.getItem("token")) {
        this.$message({
          showClose: true,
          message: "请先登录",
        });
        //提示登录框
        setTimeout(() => {
          this.handleZhu();
        }, 300);
        return;
      }
      if (this.addBoxRound <= 0) {
        this.$message({
          showClose: true,
          message: "请添加对战箱子~~",
        });
        return;
      }
      for (let i = 0; i < this.addBoxDdata.length; i++) {
        if (this.addBoxDdata[i].sun_d != 0) {
          for (let j = 0; j < this.addBoxDdata[i].sun_d; j++) {
            this.addBoxDdataList.push(this.addBoxDdata[i].id);
          }
        }
      }
      // console.log((this.addBoxDdataList).toString()); 拿到创建房子的参数
      // console.log(this.addhouseindex); 0双人 1三人  2四人
      // console.log(this.client_id);
      const loading = this.$loading({
        lock: true,
        text: "创建中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.$axios({
        url: "/worker/against/room/create",
        method: "post",
        data: {
          client_id: this.client_id,
          pond: this.addBoxDdataList.toString(),
          type: this.addhouseindex + 2,
        },
      }).then((res) => {
        this.addBoxDdataList = [];
        loading.close();
        if (res.data.status === 200) {
          this.$message({
            showClose: true,
            message: res.data.data.msg,
            type: "success",
          });
          this.addBoxDdata = [];
          this.addBoxRound = 0;
          this.isaddhouse = false;
          //扣除抽奖金额
          let datapa =
            parseFloat(this.$store.state.userdata.coin) -
            parseFloat(this.addBoxtotal);
          datapa = datapa.toFixed(2);
          this.$store.commit("usercoin_up", datapa);
          //总额恢复为0
          this.addBoxtotal = 0;
          this.$router.push({
            path: "/RoomBoxBattle",
            query: { id: res.data.data.id },
          });
        } else {
          this.$message({
            showClose: true,
            message: res.data.msg,
            type: "error",
          });
        }
      });
    },
    //获取用户对战房
    getuserroom(page) {
      this.Battlerecord = [];
      var npage = 1;
      if (page) {
        npage = page;
      }
      this.$axios({
        url: "/worker/against/room/user/get",
        method: "post",
        data: {
          page: npage,
        },
      }).then((res) => {
        if (res.status === 200) {
          // this.Battlerecord = res.data.data
          this.Battlerecordcount = res.data.data.count;
          res.data.data.room.map((item) => {
            // 把箱子id取出来转换为数组  然后数组去遍历出所有id对应的箱子 拿到数组  放会每个item里面
            let arr = [];
            let lengt = item.info.pond_id.split(",");
            for (let i = 0; i < lengt.length; i++) {
              for (let j = 0; j < item.pond.length; j++) {
                if (lengt[i] == item.pond[j].id) {
                  arr.push(item.pond[j]);
                }
              }
            }
            item.newpond = arr;
            this.Battlerecord.push(item);
          });
        }
      });
    },
    //分页
    pagedata(key) {
      if (this.isp == 2) {
        this.getuserroom(key);
      } else if (this.isp == 1) {
        this.getroomList(key);
      }
    },

    //获取房间列表
    getroomList(page) {
      this.BattlerecordList = [];
      var npage = 1;
      if (page) {
        npage = page;
      }
      this.$axios({
        url: "worker/against/room/list",
        method: "post",
        data: {
          page: npage,
        },
      }).then((res) => {
        if (res.status === 200) {
          // this.Battlerecord = res.data.data
          this.BattlerecordListcount = res.data.data.count;
          res.data.data.room.map((item) => {
            // 把箱子id取出来转换为数组  然后数组去遍历出所有id对应的箱子 拿到数组  放会每个item里面
            let arr = [];
            let lengt = item.info.pond_id.split(",");
            for (let i = 0; i < lengt.length; i++) {
              for (let j = 0; j < item.pond.length; j++) {
                if (lengt[i] == item.pond[j].id) {
                  arr.push(item.pond[j]);
                }
              }
            }
            item.newpond = arr;
            this.BattlerecordList.push(item);
          });
        }
      });
    },
    //查找房间
    searchRoom() {
      // console.log(this.searchRoominput);
      if (this.searchRoominput == "") {
        // this.getroomList()
        return;
      } else {
        this.$axios({
          url: "/worker/against/room/gameid",
          method: "post",
          data: {
            id: this.searchRoominput,
          },
        }).then((res) => {
          if (res.data.status === 200) {
            this.Verificationgame = res.data.data;
            //如果改房间没有开奖提示
            if (res.data.data.datasu.length == 0) {
              this.$message({
                showClose: true,
                message: "该房间还未开奖~~",
              });
              return;
            }
            for (let i = 0; i < res.data.data.datasu.length; i++) {
              for (let j = 0; j < res.data.data.user.length; j++) {
                if (res.data.data.datasu[i].uid == res.data.data.user[j].uid) {
                  this.Verificationgame.user[j].su = res.data.data.datasu[i];
                }
              }
            }
            //胜利者
            for (let i = 0; i < res.data.data.user.length; i++) {
              if (res.data.data.user[i].win == 1) {
                // this.Verificationgamevt.user = res.data.data.user[i].username;
                // this.Verificationgamevt.id = i;
                this.Verificationgamevt++
              }
            }

            this.isVerificationgame = true;
          } else {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: "error",
            });
          }
        });
      }
    },
    //跳转对战房间
    toBattlerooms(item) {
      this.$router.push({ path: "/RoomBoxBattle", query: { id: item } });
    },
  },
};
</script>

<style lang="less" scoped>
//默认手机端隐藏
.TopApp {
  display: none;
}
.right_top {
  display: none;
}
.big {
  margin: 10px auto;
  padding: 0 2%;
  max-width: 1600px;
}
.big_main {
  display: flex;
  justify-content: space-evenly;
}
.left {
  width: 239px;
}
.left_top {
  height: 95px;
  border: 1px solid rgba(255, 153, 57, 0.68);
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  padding: 8px 12px;
}
.left_data {
  margin-left: 20px;
  h4 {
    font-size: 20px;
    font-weight: 700;
    margin-bottom: 15px;
    white-space: nowrap;
    overflow: hidden;
  }
}
.left_top_logo {
  width: 76px;
  height: 80px;
}
.left_data_u {
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 32px;
    height: 32px;
    border-radius: 50%;
  }
}
.left_data_user {
  width: 87px;
  margin-left: 10px;
  p {
    font-weight: 400;
    color: #ff9939;
  }
  .left_data_user_name {
    font-weight: 400;
    color: #fffefa !important;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
.left_li_title {
  background: url("../assets/img/battleBox/zrtop.png") 50% no-repeat;
  height: 36px;
  line-height: 36px;
  padding-left: 20px;
  margin-top: 10px;
}
.left_ui_ {
  padding: 10px 0;
  background: rgba(17, 17, 17, 0.6);
}
.left_ui_li {
  display: flex;
  padding: 10px 0;
  align-items: center;
  justify-content: space-evenly;
  .left_ui_user_img {
    position: relative;
    width: 42px;
    height: 42px;
    .left_ui_user_img_img {
      width: 42px;
      height: 42px;
      border-radius: 50%;
    }
    .left_ui_user_top {
      position: absolute;
      top: -12px;
      left: 10px;
      width: 23px;
      height: 19px;
    }
  }
}
.left_ui_li:hover {
  background: hsla(0, 0%, 100%, 0.05);
}
.left_ui_user_img_img0 {
  border: 2px solid gold;
}
.left_ui_user_img_img1 {
  border: 2px solid silver;
}
.left_ui_user_img_img2 {
  border: 2px solid #6b5505;
}
.left_ui_li_user-name {
  width: 100px;
  padding-right: 10px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.left_ui_li_user_balance {
  color: #ff9939;
  width: 50px;
}
.main {
  flex: 1;
  background: rgba(17, 11, 5, 0.6);
  margin: 0 20px;
  padding: 20px;
}
.main_title {
  display: flex;
  .main_title_Battle {
    display: flex;
    align-items: center;
    border-right: 1px #666 solid;
    p {
      margin-right: 10px;
      width: 80px;
      height: 34px;
      border: 1px solid hsla(0, 0%, 100%, 0.5);
      border-radius: 10px;
      text-align: center;
      line-height: 34px;
      font-weight: 700;
      cursor: pointer;
    }
    p:hover {
      background: #ff9939;
    }
    .isp {
      background: #ff9939;
    }
    p:nth-child(3) {
      margin-right: 20px;
    }
  }
  .addBattle {
    display: flex;
    padding: 0 20px;
    align-items: center;
    .addBattle_buttom {
      width: 100px;
      height: 34px;
      background: #5855d5;
      border-radius: 10px;
      text-align: center;
      line-height: 34px;
      font-weight: 700;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      justify-content: center;
      margin-right: 9px;
      cursor: pointer;
    }
    .addBattle_buttom:hover {
      box-shadow: 0 0 8px #5855d5;
      background: #6562ea;
    }
    .addBattle_rule {
      width: 100px;
      height: 34px;
      text-align: center;
      line-height: 34px;
      font-weight: 700;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      justify-content: center;
      cursor: pointer;
    }
    .addBattle_i {
      margin: 0 5px;
    }
  }
  .main_input {
    margin-left: auto;
    display: flex;
    p {
      width: 100px;
      height: 34px;
      background: #5855d5;
      border-radius: 10px 0 0 10px;
      text-align: center;
      line-height: 34px;
      font-weight: 700;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      justify-content: center;
      cursor: pointer;
    }
    input {
      width: 160px;
      height: 34px;
      border-radius: 0 10px 10px 0;
      border: 1px solid #5855d5;
      background: rgba(88, 85, 213, 0.2);
      outline: none;
      font-size: 12px;
      font-weight: 700;
      color: #ccc;
      padding-left: 15px;
    }
  }
}
.main_data {
  padding: 0 30px;
  text-align: center;
  .main_data_title {
    display: flex;
    font-size: 14px;
    font-weight: 700;
    color: #ccc;
    margin-top: 10px;
    .main_data_casename {
      width: 42%;
    }
    .main_data_user {
      width: 22%;
      text-align: center;
    }
    .main_data_time {
      width: 17%;
      text-align: center;
    }
    .main_data_total {
      width: 19%;
      text-align: center;
    }
  }
  .main_data_content {
    display: flex;
    height: 91px;
    background: rgba(24, 20, 13, 0.6);
    margin-bottom: 10px;
    .main_data_casename_img {
      display: flex;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      justify-content: center;
      width: 42%;
      border-right: 1px solid #0d0a05;
      .main_data_casename_backimg {
        background-repeat: no-repeat;
        background-size: 100% 100%;
        width: 60px;
        height: 44px;
        line-height: 44px;
        img {
          width: 40px;
          height: 24px;
          margin-right: 10px;
        }
      }
    }
  }
  .main_data_history_user {
    width: 22%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    border-right: 1px solid #0d0a05;
    border-left: 1px solid #0d0a05;
    .avatar-container {
      position: relative;
      img {
        width: 28px;
        height: 28px;
        margin-right: 10px;
        border-radius: 50%;
      }
      ._img_victory {
        position: absolute;
        top: 12px;
        left: -15px;
        width: 60px;
        height: 20px;
      }
    }
  }
  .main_history_time {
    width: 17%;
    text-align: center;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    color: #ccc;
    border-right: 1px solid #0d0a05;
    border-left: 1px solid #0d0a05;
    .main_history_time_copy{
      position: relative;
      cursor: pointer;
      span{
        position: absolute;
        right: -30px;
        font-size: 12px;
        display: none;
      }
    }
    .main_history_time_copy:hover{
      .main_history_time_copy_span{
        display: block;
      }
    }
  }
  .main_history_total {
    width: 19%;
    text-align: center;
    font-size: 20px;
    color: #ff9939;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    border-left: 1px solid #0d0a05;
    img {
      margin-right: 11px;
    }
  }
}
.main-rooms {
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  margin: 0 1.25%;
}
.main-battle-rooms:hover {
  transition: all 0.5s;
  transform: translateY(-8px);
}
@keyframes slide-in-fwd-centers {
  0% {
    transform: scale(0);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
.main-battle-rooms {
  animation: slide-in-fwd-centers 0.4s;
  display: flex;
  margin: 0 1.25%;
  width: 30%;
  min-height: 200px;
  border-radius: 20px;
  overflow: hidden;
  margin-top: 20px;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  background-color: #1e1b15;
  .main-battle-room__info {
    flex: 1;
    padding: 4% 8%;
    text-align: center;
  }
  .battle-room-status_finished {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-left: 5px;
    span {
      margin-left: 8px;
    }
  }
  .battle-room-status__status {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .state_test1 {
    height: 9px;
    width: 9px;
    border-radius: 50%;
    box-shadow: 0 0 0 4px #3a3833;
    background-color: #ababab;
  }
  .state_test2 {
    height: 9px;
    width: 9px;
    border-radius: 50%;
    background-color: #54d454;
    animation: waiting 0.8s linear infinite alternate;
  }
  @keyframes waiting {
    from {
      box-shadow: 0 0 0 0px #294022;
    }
    to {
      box-shadow: 0 0 0 4px #294022;
    }
  }
  .state_test3 {
    img {
      width: 25px;
      height: 20px;
      animation: rotate 2s linear infinite;
    }
  }
  @keyframes rotate {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(359deg);
    }
  }
  .area-battle-room__price {
    margin: 10px 0;
    text-align: center;
    .area-battle-room__price__label {
      margin-right: 4px;
      color: #ccc;
      font-size: 14px;
    }
    .area-battle-room__price__value {
      color: #ffc21a;
      font-size: 14px;
    }
  }
  .area-battle-room__button.area-battle-room__button_status-2 {
    border-color: #666;
    background-color: hsla(0, 0%, 40%, 0.2);
  }
  .area-battle-room__button.area-battle-room__button_status-2:hover {
    background-color: hsla(0, 0%, 40%, 0.4);
  }
  .area-battle-room__button {
    cursor: pointer;
    outline: none;
    border: 2px solid transparent;
    border-radius: 10px;
    padding: 4px 20px;
    color: #fff;
    font-size: 14px;
    font-weight: 700;
    background-color: transparent;
    -webkit-transition: background-color 0.4s linear,
      -webkit-box-shadow 0.4s linear;
    transition: background-color 0.4s linear, -webkit-box-shadow 0.4s linear;
    transition: background-color 0.4s linear, box-shadow 0.4s linear;
    transition: background-color 0.4s linear, box-shadow 0.4s linear,
      -webkit-box-shadow 0.4s linear;
  }
}
.area-battle-room__divider {
  height: 80%;
  width: 1px;
  background-color: #545454;
  min-height: 150px;
}
.area-battle-room__awards {
  display: flex;
  height: 100%;
  // width: 16%;
  min-height: 150px;
  overflow: auto;
  padding: 4%;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: space-evenly;
  .area-battle-room__awards_backimg {
    background-repeat: no-repeat;
    background-size: 100% 100%;
    width: 40px;
    height: 38px;
    img {
      width: 35px;
      height: 30px;
      margin-top: 5px;
    }
  }
}
.area-battle-room__divider {
  height: 80px;
  width: 1px;
  background-color: #545454;
}
.main_battle_user {
  position: relative;
  width: 100%;
  min-width: 170px;
  padding-top: 62%;
  overflow: hidden;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  border-radius: 100vh;
  box-shadow: inset 0 0 8px 4px rgb(49, 48, 48);
  .main_battle_user_victory {
    position: absolute;
    width: 60px !important;
    height: 20px;
    top: 57px;
    left: 21px;
  }
  .main_battle_user_victory1 {
    position: absolute;
    width: 60px !important;
    height: 20px !important;
    top: 10px;
    left: 0px;
  }

  .main_battle_vs {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 32%;
    padding-top: 32%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    background-position: 50%;
    background-size: contain;
  }
  .main_battle_user2 {
    position: absolute;
    top: 10px;
    left: 57px;
    width: 60px;
    height: 30px;
    img {
      width: 30px;
      height: 30px;
      border-radius: 50%;
    }
  }
  .main_battle_user1 {
    position: absolute;
    top: 41px;
    left: 90px;
    width: 60px;
    height: 30px;
    img {
      width: 30px;
      height: 30px;
      border-radius: 50%;
    }
  }
  .main_battle_user0 {
    position: absolute;
    top: 41px;
    left: 22px;
    width: 60px;
    height: 30px;
    img {
      width: 30px;
      height: 30px;
      border-radius: 50%;
    }
  }
  .main_battle_user3 {
    position: absolute;
    top: 70px;
    left: 57px;
    width: 60px;
    height: 30px;
    img {
      width: 30px;
      height: 30px;
      border-radius: 50%;
    }
  }
  .main_battle_user_wu {
    width: 27px !important;
    height: 27px !important;
  }
}
.area-battle-rooms__see-more-button {
  outline: none;
  cursor: pointer;
  border: 2px solid #666;
  border-radius: 10px;
  padding: 8px 28px;
  color: #fff;
  font-size: 16px;
  font-weight: 700;
  background-color: hsla(0, 0%, 40%, 0.4);
  -webkit-transition: background-color 0.4s linear;
  transition: background-color 0.4s linear;
  margin-top: 20px;
}
.right {
  width: 191px;
  max-height: 1050px;
  background: rgba(0, 0, 0, 0.6);
  margin-bottom: 30px;
}
.right_top {
  max-height: 1050px;
  background: rgba(0, 0, 0, 0.6);
  margin-bottom: 30px;
}
.right_title {
  font-size: 20px;
  font-weight: 700;
  text-align: center;
  margin-top: 19px;
}
.right_p {
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  color: #ccc;
  padding-bottom: 20pxpx;
}
.right_ul_li {
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  .right_ul_li_box {
    background-repeat: no-repeat;
    background-size: 100% 100%;
    width: 80px;
    height: 80px;
    line-height: 80px;
    img {
      width: 60px;
      margin-left: 5px;
    }
  }
  .right_ul_li_data {
    margin-left: 20px;
    p {
      width: 65px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      font-size: 12px;
    }
    p:nth-child(1) {
      color: #ffc11a;
    }
  }
}
.right_ul_li:hover {
  background: hsla(0, 0%, 100%, 0.05);
}
.backghui {
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.7);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 12;
  .boxdetails {
    min-width: 666px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    animation: slide-in-fwd-center 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94)
      both;
  }
}
.boxdetails_title {
  display: flex;
  height: 54px;
  color: #fff;
  background: #39332b;
  justify-content: flex-start;
  align-items: center;
  .boxdetails_title_data {
    background-repeat: no-repeat;
    background-size: 100% 100%;
    width: 70px;
    height: 54px;
    line-height: 54px;
    margin-right: 15px;
    img {
      width: 50px;
      height: 50px;
      margin-left: 10px;
    }
  }

  i {
    margin-left: auto;
    padding-right: 20px;
    cursor: pointer;
  }
  p {
    font-size: 16px;
  }
}
.boxdetails_data {
  min-height: 466px;
  background: #292521;
  padding: 20px 25px;
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  width: 950px;
  .boxdetails_data_box {
    margin: 0 5px;
    margin-bottom: 20px;
    background: linear-gradient(180deg, #432e19, rgba(43, 44, 46, 0));
    border-top: 2px solid #ff9939;
    width: 170px;
    height: 179px;
    position: relative;
    text-align: center;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    img {
      width: 84px;
      height: 64px;
    }
    .boxdetails_data_box_sum {
      color: #fff;
      font-size: 12px;
      width: 60px;
      height: 18px;
      text-align: center;
      line-height: 18px;
      position: absolute;
      top: 4px;
      right: 0;
      background: #212529;
    }
    .boxdetails_data_box_sum:before {
      content: "";
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 0 14px 18px 0;
      border-color: transparent #212529 transparent transparent;
      position: absolute;
      right: 100%;
    }
    .boxdetails_data_box_name {
      padding: 14px 14px 9px 15px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      width: 100%;
    }
    span {
      color: #ff9939;
    }
  }
}
.rule {
  min-width: 666px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  animation: slide-in-fwd-center 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
}
@keyframes slide-in-fwd-center {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
.rule_title {
  display: flex;
  height: 54px;
  color: #fff;
  background: #39332b;
  justify-content: flex-start;
  align-items: center;
  i {
    padding-right: 20px;
    cursor: pointer;
  }
  p {
    font-size: 16px;
    margin: auto;
    line-height: 54px;
    font-weight: 700;
  }
}
.rule_data {
  min-height: 266px;
  background: #292521;
  padding: 20px 25px;
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  p {
    line-height: 30px;
    font-size: 14px;
  }
}
.addhouse {
  min-width: 666px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  animation: slide-in-fwd-center 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
}
.addhouse_title {
  display: flex;
  height: 54px;
  color: #fff;
  background: #39332b;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  ._title_round {
    font-weight: 700;
    span {
      font-size: 30px;
      color: #fff;
    }
    margin-right: 30px;
  }
  .addhouse_sum {
    flex: 1;
    text-align: center;
  }
  ._title_model {
    display: flex;
    align-items: center;
    p {
      margin-right: 10px;
      width: 80px;
      height: 34px;
      border: 1px solid hsla(0, 0%, 100%, 0.5);
      border-radius: 10px;
      text-align: center;
      line-height: 34px;
      font-weight: 700;
      cursor: pointer;
    }
    p:hover {
      background: #ff9939;
    }
    .isaddhouse {
      background: #ff9939;
    }
    // p:nth-child(3){
    //     margin-right: 20px;
    // }
  }
  .addhouse_sum {
    span {
      margin-left: 3px;
      font-size: 30px;
      font-weight: 700;
      color: #ff9939;
    }
  }
  i {
    cursor: pointer;
  }
}
.addhouse_main {
  min-height: 500px;
  width: 800px;
  background: #292521;
  padding: 0 25px;
  display: flex;
  flex-direction: column;
  position: relative;
  .addhouse_main_p {
    font-weight: 700;
    color: #999;
    font-size: 14px;
    line-height: 52px;
  }
  .addhouse_main_ul {
    display: flex;
    flex-wrap: wrap;
  }
  .addhouse_main_li {
    margin: 0 10px;
    position: relative;
    width: 128px;
    height: 173px;
    background: #030303;
    border-radius: 10px;
    padding: 12px 10px;
    margin-bottom: 10px;
    cursor: pointer;
    position: relative;
    -webkit-transition: background 0.2s linear;
    transition: background 0.2s linear;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .addhouse_main_box {
      background-repeat: no-repeat;
      background-size: 100% 100%;
      width: 98px;
      height: 70px;
      line-height: 70px;
      img {
        width: 78px;
        height: 50px;
        margin-left: 5px;
      }
    }

    .addhouse_main_li_sum {
      display: flex;
      -webkit-box-pack: justify;
      -ms-flex-pack: justify;
      justify-content: space-between;
      height: 18px;
      align-items: center;
      p {
        line-height: 18px;
        font-size: 14px;
        color: #fff;
        font-weight: 700;
      }
    }
    .addhouse_main_li_name {
      font-size: 12px;
      color: #999;
      font-weight: 700;
      text-align: center;
    }
    span {
      font-size: 12px;
      color: #ff9939;
      font-weight: 700;
      margin-top: 6px;
      text-align: center;
    }
  }
  .addiconfont {
    display: none;
    position: absolute;
    top: calc(50% - 25px);
    left: calc(50% - 25px);
    width: 50px;
    height: 50px;
    background: rgba(0, 0, 0, 0.7);
    border-radius: 50%;
    text-align: center;
    i {
      line-height: 50px;
    }
  }
  .addhouse_main_li:hover {
    .addiconfont {
      display: block;
    }
  }
  .addhouse_main_buttom {
    width: 100px;
    height: 38px;
    border-radius: 10px;
    text-align: center;
    line-height: 38px;
    font-size: 16px;
    font-weight: 700;
    color: #fff;
    background: #ff9939;
    cursor: pointer;
    margin: 10px auto;
    position: absolute;
    bottom: 0px;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
.Verificationgame {
  min-width: 666px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  animation: slide-in-fwd-center 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
}
.Verificationgame_title {
  display: flex;
  height: 54px;
  color: #fff;
  background: #39332b;
  justify-content: flex-start;
  align-items: center;
  i {
    padding-right: 20px;
    cursor: pointer;
  }
  p {
    font-size: 16px;
    margin: auto;
    line-height: 54px;
    font-weight: 700;
  }
}
.Verificationgame_main {
  background: #292521;
}
.Verificationgame_main_tit_ {
  display: flex;
  justify-content: space-between;
  padding: 20px 30px;
}
.Verificationgame_youxi {
  width: 248px;
  height: 60px;
  border: 1px solid rgba(62, 62, 62, 0.5);
  border-radius: 10px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  margin-bottom: 10px;
  padding-left: 20px;
  img {
    margin-right: 19px;
  }
  .Verificationgame_youxi_data {
    h4 {
      font-size: 16px;
      font-weight: 700;
      color: #fff;
    }
    p {
      font-size: 12px;
      font-weight: 700;
      color: #999;
    }
  }
}
.win_user {
  width: 238px;
  height: 130px;
  border: 1px solid rgba(62, 62, 62, 0.5);
  border-radius: 10px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  img {
    width: 28px;
    height: 28px;
    margin-bottom: 10px;
  }
  h4 {
    font-size: 16px;
    font-weight: 700;
    color: #fff;
  }
  .win_user_data {
    text-align: center;
    margin: 0 20px;
  }
  .win_user_data_vit {
    display: flex;
    span {
      font-size: 12px;
      font-weight: 700;
      color: #96a5ff;
      margin-right: 10px;
    }
    p {
      font-size: 12px;
      font-weight: 700;
    }
  }
}
.verification_model__content__top__main {
  width: 92%;
  height: 60px;
  border: 1px solid rgba(62, 62, 62, 0.5);
  border-radius: 10px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  padding-left: 20px;
  margin: 0 auto;
  img {
    margin-right: 13px;
  }
  .verification_model__content__top__header__left__noGame {
    font-size: 16px;
    font-weight: 700;
    color: #fff;
  }
  .verification_model__content__top__header__left__num {
    font-size: 12px;
    font-weight: 700;
    color: #999;
  }
}
.verification_model__content__title {
  color: #fff;
  line-height: 45px;
  font-size: 16px;
  font-weight: 700;
  padding-left: 40px;
}
.verification_model__tail__item {
  width: 118px;
  margin-right: 10px;
  border: 1px solid rgba(62, 62, 62, 0.5);
  border-radius: 10px;
  text-align: center;
  .verification_model__tail__item_user {
    position: relative;
  }
  .verification_model__tail__item_user_victory {
    position: absolute;
    width: 60px;
    height: 20px;
    top: 30px;
    left: 27px;
  }
  img {
    width: 46px;
    height: 46px;
    border-radius: 50%;
    margin-top: 5px;
  }
  .verification_model__tail__item_p {
    margin: 5px 0;
    font-size: 14px;
    font-weight: 700;
    color: #fff;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding: 10px;
    width: 100%;
    text-align: center;
  }
  .verification_model__tail__item_p_span {
    font-size: 14px;
    font-weight: 700;
    color: #96a5ff;
    margin-bottom: 5px;
    display: block;
  }
  .verification_model__tail {
    padding-bottom: 8px;
    border-top: 1px solid #262b2d;
    p {
      font-size: 14px;
      font-weight: 700;
      color: #fff;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      padding: 10px;
      width: 100%;
      text-align: center;
    }
  }
  .verification_model__span {
    display: flex;
    justify-content: space-around;
    .verification_model__span1 {
      font-size: 12px;
      font-weight: 700;
      color: #999;
      text-align: center;
    }
    .verification_model__span2 {
      color: #ff9939;
    }
  }
}
.verification_model__tail_big {
  height: 200px;
  overflow-x: scroll;
}
//手机排行榜
.TopApp {
  position: fixed;
  top: 60%;
  left: 0;
  cursor: pointer;
  border-radius: 2px 8px 8px 2px;
  padding: 16px 4px;
  background: #6151d8;
  width: 8vw;
  z-index: 9999;
  transition: all 0.3s ease;
}
//
@media screen and (max-width: 800px) {
  //打开隐藏的两个div
  .TopApp {
    display: block;
  }
  .right_top {
    display: block;
  }
  .addhouse {
    min-width: 0;
    width: 92%;
    top: 53%;
  }
  .addhouse_title {
    padding: 0 2px;
  }
  ._title_round {
    margin-right: 0px !important;
  }
  ._title_model {
    p {
      margin-right: 0px !important;
      width: 58px !important;
    }
  }
  .addhouse_sum {
    margin-left: 0px !important;
    font-size: 15px !important;
    span {
      font-size: 16px !important;
    }
  }
  .addhouse_main {
    min-width: 0;
    width: 100%;
  }
  .addhouse_main_li {
    width: 43.8% !important;
  }
  .addhouse_main_ul {
    height: 340px;
    overflow-y: scroll;
  }
  .rule {
    width: 98%;
    min-width: 0;
  }
  .boxdetails {
    width: 98%;
    min-width: 0 !important;
  }
  .boxdetails_data {
    width: 100%;
    height: 300px;
    overflow-x: scroll;
  }
  .boxdetails_data_box {
    width: 46% !important;
  }
  .Verificationgame {
    width: 90% !important;
    min-width: 0 !important;
  }
  .Verificationgame_main_tit_ {
    padding: 10px 5px;
  }
  .Verificationgame_youxi {
    padding-left: 0px;
    width: 175px;
  }
  .win_user_data {
    margin: 0 !important;
  }
  .participateUser {
    height: 240px;
    overflow: scroll;
    justify-content: flex-start !important;
  }

  //先隐藏左右
  .left {
    display: none;
  }
  .right {
    display: none;
  }

  .main {
    margin: 0;
    padding: 0;
  }
  .main_title {
    flex-wrap: wrap;
    justify-content: center;
    .main_title_Battle {
      border: none !important;
    }
  }
  .main_title_Battle {
    padding: 0 13% !important;
    width: 100%;
    justify-content: space-between;
  }
  .addBattle {
    padding: 10px 13% !important;
    width: 100%;
    justify-content: space-between;
    .addBattle_rule {
      width: 150px !important;
      padding-right: 15px;
    }
  }
  .main_input {
    margin-left: 0 !important;
    width: 100%;
    padding: 0 13%;
    justify-content: flex-start;
  }
  .main_data {
    padding: 0;
  }
  .main-battle-rooms {
    width: 100% !important;
  }
  .main_battle_user {
    width: 179px;
    padding-top: 0;
    height: 109px;
  }
  .main_data_title {
    width: 100%;
    justify-content: space-between;
  }
  .main_data_casename_img {
    width: 30% !important;
    overflow-x: scroll;
    justify-content: flex-start !important;
    margin-left: 10px;
  }
  .main_data_casename {
    width: 30% !important;
  }
  .main_data_history_user {
    width: 25% !important;
    overflow-x: scroll;
    justify-content: flex-start !important;
  }
  .main_data_box {
    width: 100vw;
  }
  .right_top {
    width: 100%;
  }
  .left_ui_li_user-name {
    padding: 0 10px;
  }
}
</style>